import { Popover } from '@farol-ds/react'
import { ReactNode, useState } from 'react'

import { TopbarUser } from '../../types'
import { handleSetManageUsersItemsSeen, isManageUsersItemsSeen } from '../../utils'
import styles from './topbar-manage-users-popover.module.scss'

interface TopbarManageUsersPopoverProps {
  user?: TopbarUser
  children: ReactNode
}

export const TopbarManageUsersPopover = ({ user, children }: TopbarManageUsersPopoverProps) => {
  const isManageUsersItemsNotSeen = !isManageUsersItemsSeen(user)
  const [isOpen, setIsOpen] = useState(isManageUsersItemsNotSeen)

  const onOpenChange = (open: boolean) => {
    setIsOpen(open)
    if (!open) handleSetManageUsersItemsSeen()
  }

  return (
    <Popover open={isOpen} onOpenChange={onOpenChange} placement="bottom-end" type="highlight">
      <Popover.Anchor asChild>{children}</Popover.Anchor>
      <Popover.Content className={styles.content} onClick={(e) => e.stopPropagation()}>
        <Popover.ContentClose />
        <Popover.ContentTitle>Gerencie os usuários da conta</Popover.ContentTitle>
        <Popover.ContentDescription>
          Convide, contrate e gerencie os usuários associados à sua conta
        </Popover.ContentDescription>
      </Popover.Content>
    </Popover>
  )
}
